import { useMemo } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from "recharts";
import { EmptyScreen } from "../../../misc";
import { CustomTooltip } from "@/components/graph/misc";
import { CustomXAxisTick, CustomYAxisBytesTick, roundToTwoDecimalPlaces } from "./utils";

interface BytesScannedGraphProps {
  data: Array<{
    date: string;
    bytes_scanned: number;
    bytes_scanned_ui: string;
  }>;
}

const BytesScannedGraph = ({ data }: BytesScannedGraphProps) => {
  const stackedData = useMemo(() => {
    if (data.length === 0) return [];
    return data.map(entry => ({
      time: entry.date,
      bytes_scanned: roundToTwoDecimalPlaces(entry.bytes_scanned / 1024 / 1024 / 1024),
      bytes_scanned_ui: entry.bytes_scanned_ui,
    }));
  }, [data]);

  if (stackedData && stackedData.length === 0)
    return (
      <EmptyScreen
        title="No Bytes Scanned data found"
        subTitle="No bytes scanned data found for the selected period. You will see the data once queries are executed."
      />
    );

  return (
    <ResponsiveContainer minHeight={400} className="mb-4">
      <AreaChart
        data={stackedData}
        margin={{
          top: 50,
          right: 30,
          left: 50,
          bottom: 50,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" tick={<CustomXAxisTick />} />
        <YAxis
          label={{
            value: "Total Bytes Scanned",
            fill: "black",
            angle: 0,
            position: "insideTopLeft",
            offset: -30,
          }}
          tick={<CustomYAxisBytesTick />}
        />
        <Tooltip
          content={
            <CustomTooltip
              nameValue={[
                { name: "Date", value: "time", color: "gray" },
                {
                  name: "Total bytes scanned",
                  value: "bytes_scanned_ui",
                  color: "#247EFE",
                },
              ]}
            />
          }
        />
        <Area
          type="linear"
          dataKey="bytes_scanned"
          stroke="#247EFE66"
          fill="#247EFE66"
          dot={{
            fill: "#C0D7F9",
            strokeWidth: "1px",
            stroke: "#247EFE",
          }}
          aria-label="Bytes scanned over time"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default BytesScannedGraph;